import { render, staticRenderFns } from "./HasPersonalPropertyDamagesQuestion.vue?vue&type=template&id=46de6815&scoped=true"
import script from "./HasPersonalPropertyDamagesQuestion.vue?vue&type=script&lang=ts"
export * from "./HasPersonalPropertyDamagesQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46de6815",
  null
  
)

export default component.exports